<div [ngClass]="{ 'dark text-white-dark': store()?.semidark }">
    <nav class="sidebar fixed top-0 bottom-0 z-50 h-full min-h-screen w-[280px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
        <div class="h-full bg-white dark:bg-[#0e1726]">
            <div class="flex items-center justify-between px-2 py-3">
                <a routerLink="/" class="main-logo flex shrink-0 items-center">
                    <img class="ml-[5px] w-8 flex-none" src="/assets/images/favicon.png" alt="" />
                    <span class="align-middle text-2xl font-extrabold ltr:ml-1.5 rtl:mr-1.5 dark:text-white-light lg:inline">ADA</span>
                </a>
                <a
                    href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})"
                >
                    <icon-arrow-left class="size-5 m-auto rotate-180" />
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 pt-2 py-0 font-normal text-[16px]">

                    <!-- Primary nav: same routes & permission rules as horizontal header menu -->
                    <li class="nav-item">
                        <a routerLink="/dashboard" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-layout-grid class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Dashboard' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    @if ((slugs.PD_LIST | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/pd-list" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-notes class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'PD List' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if ((slugs.AUDIT_TRAIL_LIST | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/audit-trail" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-clipboard-text class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Audit Trail' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.MANAGE_AGENT | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/manage-agent" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-cpu-bolt class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Manage Agents' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.BILLING | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/billing" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-dollar-sign-circle class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Billing' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.BILLING | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/payment-transactions" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-credit-card class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Payments' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.RULE_PACK_LIST | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/rule-packs" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-link class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Rule Packs' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.USER_LIST | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/manage-user" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-users class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'Manage Users' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }
                    @if ((slugs.PD_LINKS | hasPermission)) {
                    <li class="nav-item">
                        <a routerLink="/pd-links" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-link class="size-5 w-8 shrink-0 group-hover:!text-primary" />
                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{ 'PD Link' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    <li class="nav-item">
                        <a
                            href="javascript:;"
                            class="group"
                            (click)="$event.preventDefault(); signOut(); toggleMobileMenu()"
                        >
                            <div class="flex items-center">
                                <icon-logout class="shrink-0 group-hover:!text-primary rotate-90" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Logout' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>
                    

                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>
